import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Handles the /auth/callback route AND any URL that lands with #session_id=...
 * Exchanges the session_id for our own JWT via /auth/google/callback.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const intent = localStorage.getItem("cw_google_intent_role") || null;

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", {
          session_id: sessionId,
          intent_role: intent,
        });
        if (data.token) localStorage.setItem("cw_token", data.token);
        localStorage.removeItem("cw_google_intent_role");
        // clear the hash so the token isn't lingering in the URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        if (data.needs_role) {
          navigate("/complete-profile", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (e) {
        console.error("Google callback failed", e);
        navigate("/login?error=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-zinc-400" data-testid="auth-callback">
      <div className="flex items-center gap-3">
        <Loader2 className="w-5 h-5 animate-spin text-red-500" />
        Entrando com Google…
      </div>
    </div>
  );
}
